import { useEffect, useState } from 'react';

/**
 * props:
 * - data
 */
function ResultsTable(props) {
    const [backtest, setBacktest] = useState({});

    useEffect(() => {
        if (!props.data) return;
        setBacktest(props.data);
    }, [props.data]);

    function getCoin(coin) {
        // DECIMAL columns come back from the API as strings
        const value = Number(coin);
        return coin !== null && coin !== undefined && Number.isFinite(value)
            ? value.toFixed(5)
            : '';
    }

    // a finished run only has a whole-wallet total when endPrice was stored,
    // which keeps older backtests rendering exactly as before
    const hasTotal =
        backtest.totalPerc !== null && backtest.totalPerc !== undefined;
    const endBase = Number(backtest.endBase);
    const endPrice = Number(backtest.endPrice);
    const endQuote = Number(backtest.endQuote);
    const unrealized =
        hasTotal && endBase > 0 && endPrice > 0 ? endBase * endPrice : null;
    const endTotal = hasTotal ? endQuote + (unrealized || 0) : null;

    function getPerc(value) {
        // DECIMAL columns come back from the API as strings
        const perc = Number(value);
        if (!perc || Number.isNaN(perc)) return <></>;

        let bg;
        if (perc > 0) {
            value = '+' + perc.toFixed(4) + '%';
            bg = 'badge bg-success py-1 ms-1';
        } else if (perc < 0) {
            value = perc.toFixed(4) + '%';
            bg = 'badge bg-danger py-1 ms-1';
        } else {
            value = '0%';
            bg = 'badge bg-secondary py-1 ms-1';
        }

        return <span className={bg}>{value}</span>;
    }

    function getItem(order) {
        const date = new Date(order.transactTime);
        const frm = Intl.DateTimeFormat('en-GB', {
            dateStyle: 'short',
            timeStyle: 'short',
        }).format(date);
        return frm;
    }

    return (
        <>
            <div className="row">
                <div className="col-md-6 mb-3">
                    <b>End Base: </b> {getCoin(backtest.endBase)}{' '}
                    {getPerc(backtest.basePerc)}
                </div>
                <div className="col-md-6 mb-3">
                    <b>End Quote: </b> {getCoin(backtest.endQuote)}{' '}
                    {getPerc(backtest.quotePerc)}
                </div>
            </div>
            {endTotal !== null && (
                <div className="row">
                    <div className="col-md-6 mb-3">
                        <b>End Total: </b> {endTotal.toFixed(5)} USDT{' '}
                        {getPerc(backtest.totalPerc)}
                    </div>
                    <div className="col-md-6 mb-3">
                        {unrealized !== null && (
                            <>
                                <b>Unrealized position value: </b>
                                {getCoin(backtest.endBase)} ×{' '}
                                {getCoin(backtest.endPrice)} ={' '}
                                {unrealized.toFixed(5)} USDT
                            </>
                        )}
                    </div>
                </div>
            )}
            <div className="row divBacktestResults">
                <div className="col-md-6 mb-3">
                    <ul className="list-group">
                        <li className="list-group-item list-group-item-warning">
                            BUY ({backtest.buys})
                        </li>
                        {backtest.results &&
                            backtest.results.length &&
                            backtest.results
                                .filter(r => r.side === 'BUY')
                                .map(order => (
                                    <li
                                        key={'o' + order.transactTime}
                                        className="list-group-item"
                                    >
                                        {getItem(order)}
                                    </li>
                                ))}
                    </ul>
                </div>
                <div className="col-md-6 mb-3">
                    <ul className="list-group">
                        <li className="list-group-item list-group-item-success">
                            SELL ({backtest.sells})
                        </li>
                        {backtest.results &&
                            backtest.results.length &&
                            backtest.results
                                .filter(r => r.side === 'SELL')
                                .map(order => (
                                    <li
                                        key={'o' + order.transactTime}
                                        className="list-group-item"
                                    >
                                        {getItem(order)}
                                    </li>
                                ))}
                    </ul>
                </div>
            </div>
        </>
    );
}

export default ResultsTable;
